import React from "react";
import { useGamePublisherSessions } from "@seabrookstudios/pitch2table";
import { SessionListItemNoConvention } from "../sessions/SessionListItem";
import { AddSessionDialog } from "../sessions/AddSessionDialog";
import { useMakeListView, useMakeListBuilder, idExtractor } from "../core/useMakeLayout";
import { NoItemsFound } from "../publisher/NoItemsFound";

const NoSessions = () => (
  <NoItemsFound>
    <p>No sessions scheduled for this game and publisher combination.</p>
  </NoItemsFound>
);

const SessionListEntry = ({ item }) => {
  return <SessionListItemNoConvention session={item} />;
};

/**
 * Sessions list for a game and publisher combination
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("@seabrookstudios/pitch2table-core").PublisherId} props.publisherId
 */
export const SessionsForGamePublisher = ({ gameId, publisherId }) => {
  const Action = () => <AddSessionDialog seededGameIds={[gameId]} seededPublisherIds={[publisherId]} />;

  const useMakeList = useMakeListBuilder(
    SessionListEntry,
    idExtractor,
    "Sessions",
    NoSessions,
    Action,
    undefined,
    undefined
  );

  const useWrappedQuery = () => useGamePublisherSessions(gameId, publisherId);

  const List = useMakeListView(useWrappedQuery, [], "game-publisher-sessions", useMakeList);

  return <List />;
};
